import { useModalForm } from 'assets/components/form/modalForm/ModalForm';
import CheckInput from 'assets/components/inputs/check/CheckInput';
import { inputStyles } from 'assets/components/inputs/Input';
import CheckWrapper from 'assets/components/inputs/wrappers/CheckWrapper';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import { ContractAdjustForm } from '../Contract.AdjustDistributions';

const ContractAdjustDistributionsDocuments = () => {
  const { lang } = getLocales();
  const { form } = useModalForm<ContractAdjustForm>();

  return (
    <FormWrapper>
      <CheckWrapper>
        <CheckInput
          name="generateDocuments"
          label={lang.generateDocuments}
          onChange={form.update}
          class={inputStyles.check.switch}
          value={form.data?.generateDocuments}
          htmlElementProps={{ title: form.data?.generateDocuments ? lang.disable : lang.enable }}
        />
        &nbsp;
        <CheckInput
          name="sendDocumentForSigning"
          label={lang.sendDocumentForSigning}
          onChange={form.update}
          class={inputStyles.check.switch}
          value={form.data?.sendDocumentForSigning}
          htmlElementProps={{ title: form.data?.sendDocumentForSigning ? lang.disable : lang.enable }}
        />
      </CheckWrapper>
    </FormWrapper>
  );
};

export default ContractAdjustDistributionsDocuments;
